import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { ClientWebMailDto } from "./type";

// Admin — müşteri Web & E-posta bilgileri + askıya al/geri aç/teardown.
export const getClientWebMail = createAction(
  "GET_CLIENT_WEBMAIL",
  ({ payload, id }: SagaActionParams<ClientWebMailDto>) => ({
    payload,
    url: "/api/admin/ClientWebMail/" + id,
  })
);
export const suspendClientWebMail = createAction(
  "SUSPEND_CLIENT_WEBMAIL",
  ({ payload, id }: SagaActionParams<any>) => ({
    payload,
    body: {},
    url: "/api/admin/ClientWebMail/" + id + "/suspend",
  })
);
export const resumeClientWebMail = createAction(
  "RESUME_CLIENT_WEBMAIL",
  ({ payload, id }: SagaActionParams<any>) => ({
    payload,
    body: {},
    url: "/api/admin/ClientWebMail/" + id + "/resume",
  })
);
export const teardownClientWebMail = createAction(
  "TEARDOWN_CLIENT_WEBMAIL",
  ({ payload, id, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/ClientWebMail/" + id + "/teardown",
  })
);

const clientWebMailSaga = [
  takeLatest<any>(getClientWebMail.toString(), (p: SagaGenericParams<ClientWebMailDto>) =>
    getSaga<ClientWebMailDto>(p)
  ),
  takeLatest<any>(suspendClientWebMail.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
  takeLatest<any>(resumeClientWebMail.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
  takeLatest<any>(teardownClientWebMail.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
];

export default clientWebMailSaga;
